export default __webpack_public_path__ + "static/media/isotype_dixibox.6038180a.svg";